function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#E8ECEF"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-607 -452) translate(608 453)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#E8ECEF",
  fillRule: "nonzero",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M19.792 1.16c-.128-.08-.288-.082-.419-.008l-4.589 2.584v-1.55C14.783.978 13.835 0 12.666 0H2.119C.949.001 0 .979 0 2.185v8.63C.001 12.02.95 12.999 2.119 13h10.547c1.17-.001 2.117-.979 2.118-2.185V9.292l4.59 2.585c.13.073.29.07.418-.008.13-.079.208-.222.208-.376V1.535c0-.154-.079-.297-.208-.376zm-5.856 9.655c0 .724-.569 1.31-1.27 1.311H2.118c-.702 0-1.27-.587-1.272-1.311v-8.63c.001-.723.57-1.31 1.272-1.31h10.547c.701 0 1.27.587 1.27 1.31v8.63zm5.217-.059l-4.369-2.46V4.732l4.369-2.46v8.484z",
  transform: "translate(8 10) translate(0 .442)"
}))), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17
}))));

var SvgCamera = function SvgCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera.cced37d0.svg";
export { ForwardRef as ReactComponent };